$.fn.drags = function(opt) {
	opt = $.extend({handle:"",cursor:"move"}, opt);

	if(opt.handle === "") {
		var $el = this;
	} else {
		var $el = this.find(opt.handle);
	}

	return $el.css('cursor', opt.cursor).on("mousedown", function(e) {
		if(opt.handle === "") {
			var $drag = $(this).addClass('draggable');
		} else {
			var $drag = $(this).addClass('active-handle').parent().addClass('draggable');
		}
		var z_idx = $drag.css('z-index'),
			drg_h = $drag.outerHeight(),
			drg_w = $drag.outerWidth(),
			pos_y = $drag.offset().top + drg_h - e.pageY,
			pos_x = $drag.offset().left + drg_w - e.pageX;
		$drag.css('z-index', 1000).parents().on("mousemove", function(e) {
			$('.draggable').offset({
				top:e.pageY + pos_y - drg_h,
				left:e.pageX + pos_x - drg_w
			}).on("mouseup", function() {
				$(this).removeClass('draggable').css('z-index', z_idx);
			});
		});
		e.preventDefault(); // disable selection
	}).on("mouseup", function() {
		if(opt.handle === "") {
			$(this).removeClass('draggable');
		} else {
			$(this).removeClass('active-handle').parent().removeClass('draggable');
		}
	});
};;(function($){
	window.GlitchableImages = function(selector) {
		var base64Chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
			base64Map = base64Chars.split(""),
			reverseBase64Map = false,
			hover_img = false,
			elSelector = selector;

		function setupReverseBase64Map() {
			reverseBase64Map = {};
			base64Map.forEach(function(val, key) { 
				reverseBase64Map[val] = key;
			});
		}
		
		function detectJpegHeaderSize(data) {
			var jpgHeaderLength = 417;
			for (var i = 0, l = data.length; i < l; i++) {
				if (data[i] == 0xFF && data[i+1] == 0xDA) {
					//console.log("xxxxxxx<<<<", data[i], data[i+1], i, l);
					jpgHeaderLength = i + 2;
					return jpgHeaderLength;
				}
			}
			return jpgHeaderLength;
		}
		
		// base64 is 2^6, byte is 2^8, every 4 base64 values create three bytes
		function base64ToByteArray(str) {
			var result = [], digitNum, cur, prev;
			for (var i = 23, l = str.length; i < l; i++) {
				cur = reverseBase64Map[str.charAt(i)];
				digitNum = (i-23) % 4;
				switch(digitNum){
					//case 0: first digit - do nothing, not enough info to work with
					case 1: //second digit
						result.push(prev << 2 | cur >> 4);
						break;
					case 2: //third digit
						result.push((prev & 0x0f) << 4 | cur >> 2);
						break;
					case 3: //fourth digit
						result.push((prev & 3) << 6 | cur);
						break;
				}
				prev = cur;
			}
			return result;
		}
		
		function byteArrayToBase64(arr) {
			var result = ["data:image/jpeg;base64,"], byteNum, cur, prev;
			for (var i = 0, l = arr.length; i < l; i++) {
				cur = arr[i];
				byteNum = i % 3;
				switch (byteNum) {
					case 0: //first byte
						result.push(base64Map[cur >> 2]);
						break;
					case 1: //second byte
						result.push(base64Map[(prev & 3) << 4 | (cur >> 4)]);
						break;
					case 2: //third byte
						result.push(base64Map[(prev & 0x0f) << 2 | (cur >> 6)]);
						result.push(base64Map[cur & 0x3f]);
						break;
				}
				prev = cur;
			}
			if (byteNum === 0) {
				result.push(base64Map[(prev & 3) << 4]);
				result.push("==");
			} else if (byteNum == 1) {
				result.push(base64Map[(prev & 0x0f) << 2]);
				result.push("=");
			}
			return result.join("");
		}
		
		function glitchJpegBytes(strArr, jpgHeaderLength) {
			var rnd = Math.floor(jpgHeaderLength + Math.random() * (strArr.length - jpgHeaderLength - 4));
			strArr[rnd] = Math.floor(Math.random() * 256);
		}
		
		function glitchJpeg() {
			try {
				var glitchCopy = hover_img.dataArr.slice();
				for (var i = 0; i < 10; i++) {
					glitchJpegBytes(glitchCopy, hover_img.headerLength);
				}
				var new_img = new Image();
				new_img.onload = function() {
					// if the load event fires after we've moused off
					if (typeof(hover_img.ctx)==="undefined") return;
					hover_img.ctx.drawImage(new_img, 0, 0, hover_img.width, hover_img.height);
				};
				new_img.src = byteArrayToBase64(glitchCopy);
			}
			catch(e) {
				// nothing, we'll just assume that we moused off at the same time.
			}
		}

		function unglitch(this_img) {
			try {
				var new_img = new Image();
				new_img.onload = function() {
					this_img.ctx.drawImage(new_img, 0, 0, this_img.width, this_img.height);
				};
				new_img.src = byteArrayToBase64(this_img.dataArr);
			}
			catch(e) {
				// nothing, we'll just assume that we moused off at the same time.
			}
		}

		function setupGlitchableImage(event) {
			var img = this.page_img;

			console.log("setupGlitchableImage ", img);

			var $img = $(img);
			var $canvas = $('<canvas width="'+$img.width()+'" height="'+$img.height()+'">');

			$img.wrap('<span class="glitchable_container"></span>');
			$img.after($canvas);

			// console.log("created context for "+this.getAttribute("src"));

			try {
				img.ctx = $canvas[0].getContext('2d');
				img.ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, $img.width(), $img.height());
				img.jpgImgData = $canvas[0].toDataURL("image/jpeg");
				img.dataArr = base64ToByteArray(img.jpgImgData);
				img.headerLength = detectJpegHeaderSize(img.dataArr);
			}
			catch(e) {
				console.log("Cannot glitch "+img.getAttribute("src")+", probably due to same-origin restrictions.");
			}
		}

		function onImageMouseOver(event) {
			// console.log("onImageMouseOver: "+event);
			hover_img = $(event.target).prev("img")[0];
		}

		function onImageMouseMove(event) {
			// console.log("onImageMouseMove: "+event);
			requestAnimationFrame(glitchJpeg);
		}

		function onImageMouseOut(event) {
			// console.log("onImageMouseOut: "+event);
			unglitch(hover_img);
			hover_img = false;
		}

		function resize() {
			$(".glitchable_container canvas").each(function() {
				var $img = $(this).siblings("img");
				console.group($.trim($(this).closest("article").find("h2").text()));
				console.log(this);
				console.log("setting width to ", $img.width());
				$(this)
					.attr("width", $img.width())
					.attr("height", $img.height());
				console.log(this);
				console.groupEnd();
			});
		}

		function init() {
			if (!reverseBase64Map) {
				setupReverseBase64Map();
			}
			console.group("GlitchableImages.init: ", elSelector);
			$(elSelector).each(function() {
				if (this.ctx) {
					console.log("Skipping ", this);
					return;
				}
				this.load_img = new Image();
				this.load_img.page_img = this;
				$(this.load_img).load(setupGlitchableImage);
				this.load_img.src = this.getAttribute("src");
			});
			console.groupEnd();
			$("body")
				.on("mouseover", ".glitchable_container", onImageMouseOver)
				.on("mousemove", ".glitchable_container", onImageMouseMove)
				.on("mouseout", ".glitchable_container", onImageMouseOut);
		}

		return {
			'onResize': resize,
			'init': init
		};
	};
})(jQuery);
/*
// Infinite Scroll jQuery plugin
// copyright Paul Irish, licensed GPL & MIT
// version 1.5.100504

// home and docs: http://www.infinite-scroll.com
*/

(function(a){a.fn.infinitescroll=function(n,i){function f(){b.debug&&window.console&&console.log.call(console,arguments)}function k(){return b.localMode?a(c.container)[0].scrollHeight&&a(c.container)[0].scrollHeight:a(document).height()}function l(){c.loadingMsg.find("img").hide().parent().find("div").html(b.donetext).animate({opacity:1},2E3,function(){a(this).parent().fadeOut("normal")});b.errorCallback()}function o(){if(c.isDone){l();return false}else{var d=g.children().get();if(d.length==0)return a.event.trigger("ajaxError",
[{status:404}]);for(;g[0].firstChild;)j.appendChild(g[0].firstChild);a(b.contentSelector)[0].appendChild(j);c.loadingMsg.fadeOut("normal");if(b.animate){var e=a(window).scrollTop()+a("#infscr-loading").height()+b.extraScrollPx+"px";a("html,body").animate({scrollTop:e},800,function(){c.isDuringAjax=false})}i.call(a(b.contentSelector)[0],d);if(!b.animate)c.isDuringAjax=false}}a.browser.ie6=a.browser.msie&&a.browser.version<7;var b=a.extend({},a.infinitescroll.defaults,n),c=a.infinitescroll,g,j;i=i||
function(){};if(!function(d){for(var e in d){if(e.indexOf&&e.indexOf("Selector")>-1&&a(d[e]).length===0){f("Your "+e+" found no elements.");return false}return true}}(b))return false;c.container=b.localMode?this:document.documentElement;b.contentSelector=b.contentSelector||this;b.loadMsgSelector=b.loadMsgSelector||b.contentSelector;var m=/(.*?\/\/).*?(\/.*)/,h=a(b.nextSelector).attr("href");if(h){h=function(d){d.match(m)&&d.match(m);if(d.match(/^(.*?)\b2\b(.*?$)/))d=d.match(/^(.*?)\b2\b(.*?$)/).slice(1);
else if(d.match(/^(.*?)2(.*?$)/)){if(d.match(/^(.*?page=)2(\/.*|$)/))return d=d.match(/^(.*?page=)2(\/.*|$)/).slice(1);f("Trying backup next selector parse technique. Treacherous waters here, matey.");d=d.match(/^(.*?)2(.*?$)/).slice(1)}else{if(d.match(/^(.*?page=)1(\/.*|$)/))return d=d.match(/^(.*?page=)1(\/.*|$)/).slice(1);f("Sorry, we couldn't parse your Next (Previous Posts) URL. Verify your the css selector points to the correct A tag. If you still get this error: yell, scream, and kindly ask for help at infinite-scroll.com.");
c.isInvalidPage=true}return d}(h);if(b.localMode)a(c.container)[0].scrollTop=0;c.pixelsFromNavToBottom=k()+(c.container==document.documentElement?0:a(c.container).offset().top)-a(b.navSelector).offset().top;c.loadingMsg=a('<div id="infscr-loading" style="text-align: center;"><!--img alt="Loading..." src="'+b.loadingImg+'" /--><div>'+b.loadingText+"</div></div>");(new Image).src=b.loadingImg;a(document).ajaxError(function(d,e){f("Page not found. Self-destructing...");if(e.status==404){l();c.isDone=true;
a(b.localMode?this:window).unbind("scroll.infscr")}});a(b.localMode?this:window).bind("scroll.infscr",function(){if(!(c.isDuringAjax||c.isInvalidPage||c.isDone)){var d=0+k()-(b.localMode?a(c.container).scrollTop():a(c.container).scrollTop()||a(c.container.ownerDocument.body).scrollTop())-a(b.localMode?c.container:window).height();f("math:",d,c.pixelsFromNavToBottom);d-b.bufferPx<c.pixelsFromNavToBottom&&a(document).trigger("retrieve.infscr")}}).trigger("scroll.infscr");a(document).bind("retrieve.infscr",
function(){c.isDuringAjax=true;c.loadingMsg.appendTo(b.loadMsgSelector).show();a(b.navSelector).hide();c.currPage++;f("heading into ajax",h);g=a(b.contentSelector).is("table")?a("<tbody/>"):a("<div/>");j=document.createDocumentFragment();g.load(h.join(c.currPage)+" "+b.itemSelector,null,o)});return this}else f("Navigation selector not found")};a.infinitescroll={defaults:{debug:false,preload:false,nextSelector:"div.navigation a:first",loadingImg:"http://www.infinite-scroll.com/loading.gif",loadingText:"<em>Loading the next set of posts...</em>",
donetext:"<em>Congratulations, you've reached the end of the internet.</em>",navSelector:"div.navigation",contentSelector:null,loadMsgSelector:null,extraScrollPx:150,itemSelector:"div.post",animate:false,localMode:false,bufferPx:40,errorCallback:function(){}},loadingImg:undefined,loadingMsg:undefined,container:undefined,currPage:1,currDOMChunk:null,isDuringAjax:false,isInvalidPage:false,isDone:false}})(jQuery);
/*
 * Placeholder Shim for old browsers
 *
 * Copyright (c) 2012 Version Industries
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
 */
(function($) {
	
	$.fn.resetPlaceholder = function(){
		return this.each(function(){
			var $field = $(this);
			var placeholderText = $field.attr("placeholder") || "";
			this._hasPlaceholderShim = false;
			$field.prev("div.placeholder").remove();
		});
	};

	$.fn.initPlaceholder = function(){
		return this.each(function(){
			var $field = $(this);
			var fieldPos = $field.position();
			var placeholderText = $field.attr("placeholder") || "";
			
			if (
				placeholderText==="" ||
				!(typeof(this._hasPlaceholderShim)==="undefined" || this._hasPlaceholderShim===false) ||
				$field.is(":hidden")
			) {
				return;
			}
			this._hasPlaceholderShim = true;

			var $label = $('<div class="placeholder '+this.nodeName.toLowerCase()+'-placeholder">'+placeholderText+'</div>');
			$field
				.before($label)
				.css("zoom", "1")
				.focus(function(e){ 
					// $label.hide();
				})
				.blur(function(e){
					if ($field.val()=="") $label.show();
				})
				.keyup(function() {
					if ($field.val()=="") $label.show();
					else $label.hide();
				})
				// listen to change and onPropertyChange mainly to detect stuff like auto-fill
				// which should hide the label.
				.change(function(e){
					if ($field.val()=="") $label.show();
					else $label.hide();
				})
				.bind('onPropertyChange', function(e){
					if ($field.val()=="") $label.show();
					else $label.hide();
				});
			$label
				.addClass($field.attr("class"))
				.css({
					position:"absolute",
					textAlign:$field.css("text-align"),
					left:fieldPos.left + "px",
					top:fieldPos.top + "px",
					width:$field.width() + "px"
				})
				.hide()
				.click(function(e) { $field.focus(); return false; });
			
			// reposition after a short delay. this is to avoid issues grabbing the position
			// if the div is invisible when initially laid out.
			setTimeout(function(){
				if ($field.val()=="") $label.show();
				var fieldPos = $field.position();
				$label.css({
					left:fieldPos.left + "px",
					top:fieldPos.top + "px",
					width:($field.width() - 10) + "px"
				});
			}, 150);
		});
	};

	var updatePlaceholderShims = function() {
		if ('placeholder' in document.createElement('input')) {
			if ('placeholder' in document.createElement('textarea')) {
				return;
			}
			$("textarea").initPlaceholder();
			return;
		}
		$("input[type!=file], textarea").initPlaceholder();
	};

	$(updatePlaceholderShims);
})(jQuery);
﻿var ZALGO = {
  zalgo_up: [
    '\u030d',
    /*     Ì     */ '\u030e',
    /*     ÌŽ     */ '\u0304',
    /*     Ì„     */ '\u0305' /*     Ì…     */,
    '\u033f',
    /*     Ì¿     */ '\u0311',
    /*     Ì‘     */ '\u0306',
    /*     Ì†     */ '\u0310' /*     Ì     */,
    '\u0352',
    /*     Í’     */ '\u0357',
    /*     Í—     */ '\u0351',
    /*     Í‘     */ '\u0307' /*     Ì‡     */,
    '\u0308',
    /*     Ìˆ     */ '\u030a',
    /*     ÌŠ     */ '\u0342',
    /*     Í‚     */ '\u0343' /*     Ì“     */,
    '\u0344',
    /*     ÌˆÌ     */ '\u034a',
    /*     ÍŠ     */ '\u034b',
    /*     Í‹     */ '\u034c' /*     ÍŒ     */,
    '\u0303',
    /*     Ìƒ     */ '\u0302',
    /*     Ì‚     */ '\u030c',
    /*     ÌŒ     */ '\u0350' /*     Í     */,
    '\u0300',
    /*     Ì€     */ '\u0301',
    /*     Ì     */ '\u030b',
    /*     Ì‹     */ '\u030f' /*     Ì     */,
    '\u0312',
    /*     Ì’     */ '\u0313',
    /*     Ì“     */ '\u0314',
    /*     Ì”     */ '\u033d' /*     Ì½     */,
    '\u0309',
    /*     Ì‰     */ '\u0363',
    /*     Í£     */ '\u0364',
    /*     Í¤     */ '\u0365' /*     Í¥     */,
    '\u0366',
    /*     Í¦     */ '\u0367',
    /*     Í§     */ '\u0368',
    /*     Í¨     */ '\u0369' /*     Í©     */,
    '\u036a',
    /*     Íª     */ '\u036b',
    /*     Í«     */ '\u036c',
    /*     Í¬     */ '\u036d' /*     Í­     */,
    '\u036e',
    /*     Í®     */ '\u036f',
    /*     Í¯     */ '\u033e',
    /*     Ì¾     */ '\u035b' /*     Í›     */,
    '\u0346',
    /*     Í†     */ '\u031a' /*     Ìš     */
  ],
  zalgo_down: [
    '\u0316',
    /*     Ì–     */ '\u0317',
    /*     Ì—     */ '\u0318',
    /*     Ì˜     */ '\u0319' /*     Ì™     */,
    '\u031c',
    /*     Ìœ     */ '\u031d',
    /*     Ì     */ '\u031e',
    /*     Ìž     */ '\u031f' /*     ÌŸ     */,
    '\u0320',
    /*     Ì      */ '\u0324',
    /*     Ì¤     */ '\u0325',
    /*     Ì¥     */ '\u0326' /*     Ì¦     */,
    '\u0329',
    /*     Ì©     */ '\u032a',
    /*     Ìª     */ '\u032b',
    /*     Ì«     */ '\u032c' /*     Ì¬     */,
    '\u032d',
    /*     Ì­     */ '\u032e',
    /*     Ì®     */ '\u032f',
    /*     Ì¯     */ '\u0330' /*     Ì°     */,
    '\u0331',
    /*     Ì±     */ '\u0332',
    /*     Ì²     */ '\u0333',
    /*     Ì³     */ '\u0339' /*     Ì¹     */,
    '\u033a',
    /*     Ìº     */ '\u033b',
    /*     Ì»     */ '\u033c',
    /*     Ì¼     */ '\u0345' /*     Í…     */,
    '\u0347',
    /*     Í‡     */ '\u0348',
    /*     Íˆ     */ '\u0349',
    /*     Í‰     */ '\u034d' /*     Í     */,
    '\u034e',
    /*     ÍŽ     */ '\u0353',
    /*     Í“     */ '\u0354',
    /*     Í”     */ '\u0355' /*     Í•     */,
    '\u0356',
    /*     Í–     */ '\u0359',
    /*     Í™     */ '\u035a',
    /*     Íš     */ '\u0323' /*     Ì£     */
  ],
  zalgo_mid: [
    '\u0315',
    /*     Ì•     */ '\u031b',
    /*     Ì›     */ '\u0340',
    /*     Ì€     */ '\u0341' /*     Ì     */,
    '\u0358',
    /*     Í˜     */ '\u0321',
    /*     Ì¡     */ '\u0322',
    /*     Ì¢     */ '\u0327' /*     Ì§     */,
    '\u0328',
    /*     Ì¨     */ '\u0334',
    /*     Ì´     */ '\u0335',
    /*     Ìµ     */ '\u0336' /*     Ì¶     */,
    '\u034f',
    /*     Í     */ '\u035c',
    /*     Íœ     */ '\u035d',
    /*     Í     */ '\u035e' /*     Íž     */,
    '\u035f',
    /*     ÍŸ     */ '\u0360',
    /*     Í      */ '\u0362',
    /*     Í¢     */ '\u0338' /*     Ì¸     */,
    '\u0337',
    /*     Ì·     */ '\u0361',
    /*     Í¡     */ '\u0489' /*     Ò‰_     */
  ],
  /**
   * @function rand
   * Gets an int between 0 and max
   */
  rand: function(max) {
    return Math.floor(Math.random() * max);
  },
  /**
   * @function rand_zalgo
   * Gets a random char from a zalgo char table
   */
  rand_zalgo: function(array) {
    var ind = Math.floor(Math.random() * array.length);
    return array[ind];
  },
  /**
   * @function is_zalgo_char
   * Lookup char to know if its a zalgo char or not
   */
  is_zalgo_char: function(c) {
    var i;
    for (i = 0; i < this.zalgo_up.length; i++) {
      if (c == this.zalgo_up[i]) return true;
    }
    for (i = 0; i < this.zalgo_down.length; i++) {
      if (c == this.zalgo_down[i]) return true;
    }
    for (i = 0; i < this.zalgo_mid.length; i++) {
      if (c == this.zalgo_mid[i]) return true;
    }
    return false;
  },
  /**
   * @function convert
   * Converts txt into zalgo text.
   */
  convertChar: function(txt) {
    txt += this.rand_zalgo(this.zalgo_mid);

    for (var j = 0; j < 2; j++) {
      txt += this.rand_zalgo(this.zalgo_up);
    }
    for (var j = 0; j < 0; j++) {
      txt += this.rand_zalgo(this.zalgo_mid);
    }
    for (var j = 0; j < 2; j++) {
      txt += this.rand_zalgo(this.zalgo_down);
    }

    return txt;
  },
  /**
   * @function convert
   * Converts txt into zalgo text.
   */
  convert: function(txt, mode, up, middle, down) {
    var newtxt = '';
    if (typeof mode === 'undefined') mode = 'normal';
    if (typeof up === 'undefined') up = true;
    if (typeof middle === 'undefined') middle = true;
    if (typeof down === 'undefined') down = true;

    for (var i = 0; i < txt.length; i++) {
      if (this.is_zalgo_char(txt.substr(i, 1))) continue;

      var num_up;
      var num_mid;
      var num_down;

      //add the normal character
      newtxt += txt.substr(i, 1);

      //options
      switch (mode) {
        case 'mini':
          num_up = this.rand(8);
          num_mid = this.rand(2);
          num_down = this.rand(8);
          break;
        case 'normal':
          num_up = this.rand(16) / 2 + 1;
          num_mid = this.rand(6) / 2;
          num_down = this.rand(16) / 2 + 1;
          break;
        case 'maxi':
        default:
          num_up = this.rand(64) / 4 + 3;
          num_mid = this.rand(16) / 4 + 1;
          num_down = this.rand(64) / 4 + 3;
          break;
      }

      if (up) {
        for (var j = 0; j < num_up; j++) {
          newtxt += this.rand_zalgo(this.zalgo_up);
        }
      }
      if (middle) {
        for (var j = 0; j < num_mid; j++) {
          newtxt += this.rand_zalgo(this.zalgo_mid);
        }
      }
      if (down) {
        for (var j = 0; j < num_down; j++) {
          newtxt += this.rand_zalgo(this.zalgo_down);
        }
      }
    }

    return newtxt;
  }
};
/*globals ZALGO */
var devicePixelRatio = typeof window.devicePixelRatio === 'number' ? window.devicePixelRatio : 1;

var ScrollToEnd = (function() {
  function canScroll() {
    var $node = scrollingNode(this);
    var $parent = offsetParent(this);
    return $node.width() > $parent.width() || $node.height() > $parent.height();
  }
  function hasScrolledToAnEnd(node, scrollBuffer) {
    var $node = scrollingNode(node);
    var $parent = offsetParent(node);
    return (
      ($node.scrollTop() !== 0 &&
        $node.scrollTop() + scrollBuffer + $parent.height() >= $node.height()) ||
      ($node.scrollLeft() !== 0 && $node.scrollLeft() === $node.width() - $parent.width())
    );
  }
  function offsetParent(node) {
    return $(
      !('nodeName' in node) || node.nodeName === 'BODY' || node.nodeName === '#document'
        ? window
        : node.offsetParent
    );
  }
  function scrollingNode(node) {
    return 'nodeType' in node && node.nodeType === 1 ? $(node) : $(document);
  }
  function triggerEvent(node) {
    $(node).trigger('scrollToEnd');
  }
  function trackScroll(scrollBuffer) {
    if (arguments.length === 0) {
      scrollBuffer = 0;
    }
    return this.filter(canScroll).on('scroll', function(e) {
      hasScrolledToAnEnd(e.target, scrollBuffer) && triggerEvent(e.target);
    });
  }
  function extend($) {
    $.fn.trackScroll = trackScroll;
  }
  return {
    extend: extend
  };
})();
var HomeScroll = (function() {
  var $container;
  function Pager() {}
  Pager.prototype.currentPage = 1;
  Pager.prototype.isBusy = false;
  Pager.prototype.getNextPageURL = function() {
    return '/api/home/' + (this.currentPage + 1);
  };
  Pager.prototype.getData = function(url, callback) {
    $.ajax({
      url: url,
      dataType: 'json',
      context: this,
      success: callback
    });
  };
  Pager.prototype.advance = function() {
    if (!this.isBusy) {
      this.isBusy = true;
      this.beforeAdvance();
      this.getData(this.getNextPageURL(), function(data) {
        if (data.length) {
          this.currentPage++;
          this.onPageAdvance(data);
        }
        this.isBusy = false;
      });
    }
  };
  function appendArticles(data) {
    //console.log('appendArticles --- Adding ' + data.length + ' articles.');
    var div = document.createElement('div');
    for (var i in data) {
      div.innerHTML = data[i].html;
      $container.append($(div).children());
    }
    $container.removeClass('loading');
    // updateImageGlitching();
    fixVideoEmbedWidths();
  }
  function onDomReady($) {
    $container = $('#home-wrapper');
    if ($container.length === 0) {
      return null;
    }
    var pager = new Pager();
    pager.beforeAdvance = function() {
      $container.addClass('loading');
    };
    pager.onPageAdvance = appendArticles;
    ScrollToEnd.extend($);
    $(window)
      .trackScroll(200)
      .on('scrollToEnd', function(e) {
        pager.advance();
      });
  }
  return {
    onDomReady: onDomReady
  };
})();

// var glitcher = false;
// if (Modernizr.canvas) {
//   glitcher = new window.GlitchableImages('.media-container img, .post .image img');
// }
// function updateImageGlitching() {
//   if (glitcher) glitcher.init();
// }

function fixVideoEmbedWidths() {
  document.querySelectorAll('.client-video iframe').forEach(node => {
    const attrWidth = parseInt(node.getAttribute('width'), 10);
    const attrHeight = parseInt(node.getAttribute('height'), 10);
    const videoRatio = attrWidth / attrHeight;
    const trueWidth = node.clientWidth;
    if (trueWidth < attrWidth) {
      node.style.height = String(Math.ceil(trueWidth / videoRatio)) + 'px';
    } else {
      node.setAttribute('style', '');
    }
  });
}

(function($) {
  $(window).resize(function() {
    // if (glitcher) glitcher.onResize();
    fixVideoEmbedWidths();
  });

  $(function() {
    // line sidebar horizontal line with the top of the first image
    var margin = $('.post-title').css('marginBottom');
    if (margin !== undefined) {
      margin = parseInt(margin.replace('px', ''), 10);
      $('#sidebar').css('margin-top', $('.post-title').height() + margin + 'px');
    }

    $('footer').drags();

    // updateImageGlitching();
    fixVideoEmbedWidths();

    // make blog scroll infinitely
    $('.narrowcolumn').infinitescroll(
      {
        navSelector: 'div.navigation',
        nextSelector: 'div.alignleft > a:first',
        itemSelector: 'div.post',
        bufferPx: 1000,
        loadingImg: '',
        loadingText: '',
        donetext: ''
      },
      () => {
        // updateImageGlitching();
        fixVideoEmbedWidths();
      }
    );
  });

  $(window).load(function() {
    initHoverDistortion();
    fixVideoEmbedWidths();
  });

  function initHoverDistortion() {
    $('.logo span, h2').each(function() {
      var html = $(this).html();
      var newhtml = '';
      var inhtml = false;
      for (var i = 0; i < html.length; i++) {
        var thisChar = html.charAt(i);
        if (thisChar === '<') {
          inhtml = true;
        }
        if (inhtml || thisChar.match(/[^a-z0-9]/i)) {
          newhtml += thisChar;
        } else {
          newhtml += '<span class="zg" data-char="' + thisChar + '">' + thisChar + '</span>';
        }
        if (thisChar === '>' && inhtml) {
          inhtml = false;
        }
      }
      $(this)
        .html(newhtml)
        .find('.zg')
        .hover(onDistortableHover, onDistortableBlur);
    });
    $('.zg').each(function() {
      var $e = $(this);
      $e.css({
        width: $e.width() + 'px',
        height: $e.height() + 'px'
      });
    });
  }
  function onDistortableHover(event) {
    var $d = $(event.target);
    $d.text(ZALGO.convertChar($d.data('char')));
  }
  function onDistortableBlur(event) {
    var $d = $(event.target);
    $d.text($d.data('char'));
  }
  HomeScroll.onDomReady($);
})(jQuery);
